const isVisibleOnViewport = (element) => {
  const rect = element.getBoundingClientRect()

  return rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight +  window.pageYOffset) &&
    rect.right <= (window.innerWidth +  window.pageXOffset)
}

export default isVisibleOnViewport
